import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "orderPaymentMethods",
  pure: true,
})
export class OrderPaymentMethodsPipe implements PipeTransform {
  transform(
    paymentGateways: Record<string, any>,
    order: string[] = []
  ): { key: string; value: any }[] {
    if (!paymentGateways) {
      return [];
    }

    const entries = Object.keys(paymentGateways).map((key) => ({
      key,
      value: paymentGateways[key],
    }));

    return entries.sort((a, b) => {
      const idxA = order.indexOf(a.key);
      const idxB = order.indexOf(b.key);

      if (idxA !== -1 && idxB !== -1) return idxA - idxB;
      if (idxA !== -1) return -1;
      if (idxB !== -1) return 1;

      return a.key.localeCompare(b.key);
    });
  }
}
